
import { Link, useNavigate } from "react-router-dom";
import { UserDropdown } from "./UserDropdown";
import { useAuth } from "@/hooks/useAuth";
import { useNavConfig } from "@/hooks/useNavConfig";

interface Props { scrolled?: boolean; }

export function DesktopNavigation({ scrolled = true }: Props) {
  const { user } = useAuth();
  const { headerItems, isNavItemVisible } = useNavConfig();
  const navigate = useNavigate();

  const linkClass = `text-sm font-semibold font-primary transition-colors duration-200 ${
    scrolled ? "text-gray-700 hover:text-brand-primary" : "text-white/85 hover:text-white"
  }`;

  const handleAnchorNav = (path: string) => {
    const [route, hash] = path.split("#");
    const el = document.getElementById(hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(route || "/");
      setTimeout(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  };

  return (
    <>
      <Link to="/inicio" className={linkClass}>Início</Link>
      {headerItems.filter(isNavItemVisible).map(item =>
        item.path.includes("#") ? (
          <button key={item.id} onClick={() => handleAnchorNav(item.path)} className={linkClass}>
            {item.label}
          </button>
        ) : (
          <Link key={item.id} to={item.path} className={linkClass}>
            {item.label}
          </Link>
        )
      )}
      {user && <UserDropdown />}
    </>
  );
}
